var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.93,83.21l4.54,1.1,13.22-11.4,2.19-9s7.11,1.27,3.42,12.92-2.07,8.85-2.07,8.85S226.1,89.28,227,90.88c.68,1.15-2.49,16-4.28,24.08-.9,4.06-4.28,7.21-8.26,7.26a7,7,0,0,1-1.66-.17c-3.71-.9-21.94-8.51-21.94-8.51l-7.83-1.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.56 77.59 172.84 109.27 180.6 111.15 187.96 80.76 177.56 77.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.22,56.42l3-1,3.39-11.2-2-5.9s4.48-1.84,6.58,6.07,2,5.75,2,5.75,9.72-3.27,10.82-2.7c.79.41,4.35,10,6.23,15.17a6,6,0,0,1-2.07,7.07,4.39,4.39,0,0,1-1,.5c-2.43.82-15.47,3.07-15.47,3.07L251.55,75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.19 57.69 244.91 77.31 249.98 75.58 243.22 55.75 236.19 57.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.45 411.14 324.05 458.18 332.25 458.18 360.95 411.14 340.45 411.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.53 411.14 450.93 458.18 442.73 458.18 414.03 411.14 434.53 411.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.5,
    y: 281.29,
    width: 131.04,
    height: 131.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.45,
    y: 281.29,
    width: 131.04,
    height: 131.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.48,403.91h-113v-113h113Zm-112-1h111v-111h-111Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6,326.47c18.53.54,37.15,0,55.69.06s37.14.28,55.69,0a.26.26,0,0,0,0-.52c-18.55-.31-37.13,0-55.69,0s-37.16-.47-55.69.07a.24.24,0,0,0,0,.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.15,309.75a3.19,3.19,0,1,1-3.19-3.19A3.19,3.19,0,0,1,370.15,309.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.21,360.93a3.19,3.19,0,1,1-3.19-3.19A3.19,3.19,0,0,1,324.21,360.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.9 247.27 440.6 282.3 432.09 282.26 425.26 260.73 426.9 247.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.14 214.9 375.44 282.02 424.03 283.04 429.5 214.9 380.14 214.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385 220.3 381.08 276.18 417.21 277.87 422.26 219.97 385 220.3",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.93 228.2 390 267.48 409.93 267.48 413.45 228.2 392.93 228.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.12,
    y: 48.31,
    width: 85.82,
    height: 89.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.31,
    y: 48.31,
    width: 85.82,
    height: 89.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.85,
    y: 60.34,
    width: 62.75,
    height: 65.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.85,126.18A11.84,11.84,0,0,1,51.28,128c-1,1-2.42,2.48-4,4s-3,2.95-4.09,3.94a12.15,12.15,0,0,1-1.79,1.53A10.94,10.94,0,0,1,43,135.69c1-1.05,2.42-2.49,4-4s3-3,4.1-3.94A12,12,0,0,1,52.85,126.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.59,126a11.84,11.84,0,0,1,1.78,1.57c1,1,2.48,2.42,4,4s2.94,3,3.93,4.09a10.89,10.89,0,0,1,1.53,1.79,11.47,11.47,0,0,1-1.77-1.56c-1-1-2.48-2.42-4-4s-3-3-3.94-4.09A12.81,12.81,0,0,1,115.59,126Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42,60.51A12.45,12.45,0,0,1,117,58.73c1-1,2.42-2.48,4-4s3-2.94,4.09-3.93a13.45,13.45,0,0,1,1.79-1.54A11.21,11.21,0,0,1,125.31,51c-1,1.05-2.42,2.48-4,4s-3,3-4.1,3.94A10.93,10.93,0,0,1,115.42,60.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.68,60.67A11.84,11.84,0,0,1,50.9,59.1c-1-1-2.48-2.41-4-4s-2.94-3-3.93-4.09a11.16,11.16,0,0,1-1.53-1.8,13.05,13.05,0,0,1,1.77,1.56c1,1,2.48,2.43,4,4s2.95,3,3.94,4.1A11.68,11.68,0,0,1,52.68,60.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42,125.75s0-.11,0-.32,0-.52,0-.91c0-.81,0-2,0-3.53,0-3.09,0-7.6-.06-13.32,0-11.46-.06-27.78-.1-47.33l.2.2-62.57,0h0l.23-.23c0,24,0,46.47,0,65.41l-.2-.21,45.32.11,12.72,0,3.36,0h.87l.3,0H114.3l-3.33,0-12.67,0L52.85,126h-.2v-.2c0-18.94,0-41.4,0-65.41V60.1h.24l62.57,0h.21v.21c0,19.6-.08,36-.11,47.46,0,5.7,0,10.19,0,13.28,0,1.51,0,2.68,0,3.48,0,.39,0,.68,0,.89S115.42,125.75,115.42,125.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.41,87.66s-1.35,16.2,16.19,16.2C85.6,95.22,78.47,88.39,69.41,87.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,87.67s-16.19-1.34-16.19,16.2C94,103.87,100.77,96.74,101.5,87.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.83,78.81s-13.23,11.88.72,25C92,97,91.49,86.2,84.83,78.81Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.45,460.16c0,.15-97.3.26-217.3.26s-217.31-.11-217.31-.26,97.27-.26,217.31-.26S474.45,460,474.45,460.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.5,253c-14.27-21.83-12.19-53,4.85-72.73,5.29-6.13,12.68-11.45,20.74-10.76,8.26.7,14.91,7.78,17.42,15.68s1.64,16.45.17,24.6c-2.07,11.42-5.53,23.1-13.45,31.58S115.68,258.57,105.5,253",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.39,358c-5.38-12.54-1.48-28.41,9.09-37,3.28-2.68,7.57-4.75,11.66-3.67s7,5.37,7.55,9.66-.64,8.63-2.14,12.69c-2.1,5.7-4.94,11.4-9.79,15.05s-11.63,7.09-16.37,3.3",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,350.55c3.93-19.35-6.27-40.69-23.78-49.8-5.44-2.83-12.13-4.5-17.61-1.76s-8.3,9.65-7.86,15.91,3.46,12,6.78,17.35c4.65,7.46,10.35,14.7,18.3,18.45s18.57,6.61,24.17-.15",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46,298.24c6.83-22.05-4.76-48.77-24.06-61.42-6-3.92-13.58-6.66-20.27-4.11-6.85,2.61-10.79,10.26-11,17.59s2.61,14.4,5.85,21c4.54,9.21,10.32,18.31,19.13,23.6s23.05,10.57,30.36,3.36",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.17,406a5.79,5.79,0,0,1-.22-1.07c-.12-.8-.27-1.82-.46-3.08-.09-.67-.19-1.42-.31-2.22s-.32-1.69-.5-2.62c-.36-1.88-.73-4-1.35-6.36-.28-1.17-.58-2.4-.89-3.67s-.75-2.58-1.15-3.94c-.73-2.73-1.82-5.56-2.84-8.58a166.29,166.29,0,0,0-8.51-18.87,166.74,166.74,0,0,0-11-17.52c-2-2.52-3.71-5-5.58-7.11L59.7,327.8,57.13,325c-1.61-1.8-3.19-3.3-4.56-4.63l-1.9-1.87L49,317,46.68,315a4.1,4.1,0,0,1-.77-.78,5.8,5.8,0,0,1,.88.63l2.43,2L51,318.2l2,1.82c1.41,1.3,3,2.78,4.67,4.56l2.63,2.74,2.7,3.12c1.91,2.12,3.7,4.58,5.68,7.1a157.5,157.5,0,0,1,11.16,17.59,159.38,159.38,0,0,1,8.49,19c1,3,2.07,5.89,2.77,8.66.39,1.36.76,2.69,1.11,4s.57,2.53.84,3.71c.57,2.36.9,4.52,1.21,6.42.16.94.3,1.83.43,2.65s.16,1.55.23,2.24c.12,1.26.21,2.29.29,3.1A4.32,4.32,0,0,1,95.17,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,409.94a1.23,1.23,0,0,1,0-.44c0-.35.06-.76.09-1.28.12-1.2.27-2.83.46-4.9.1-1.07.22-2.25.35-3.53s.13-2.71.21-4.22c.11-3,.4-6.47.29-10.29q0-2.86,0-6c0-2.08-.21-4.24-.32-6.47-.15-4.49-.76-9.24-1.3-14.26a224.39,224.39,0,0,0-6.76-32.05A222.45,222.45,0,0,0,75.85,296c-2.28-4.5-4.36-8.82-6.68-12.66-1.13-1.94-2.14-3.85-3.26-5.61s-2.2-3.43-3.24-5c-2-3.26-4.11-6-5.85-8.47-.89-1.22-1.69-2.39-2.48-3.42L52.12,258l-3-3.86-.77-1c-.17-.23-.26-.36-.24-.37s.11.09.31.31l.85,1,3.18,3.75,2.29,2.73c.81,1,1.63,2.17,2.55,3.38,1.79,2.46,3.95,5.17,6,8.41,1.06,1.6,2.16,3.28,3.3,5s2.17,3.67,3.32,5.6c2.36,3.84,4.48,8.17,6.79,12.67a217.63,217.63,0,0,1,11.93,30.68,217.68,217.68,0,0,1,6.72,32.21c.51,5,1.1,9.81,1.21,14.31.09,2.25.27,4.42.27,6.51s0,4.09,0,6c.07,3.82-.27,7.28-.43,10.31-.11,1.52-.17,2.93-.29,4.23s-.3,2.46-.43,3.53c-.27,2.06-.48,3.69-.63,4.88-.07.51-.13.93-.18,1.27A1.36,1.36,0,0,1,94.67,409.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.81,195.87s-.05.15-.18.41-.37.68-.62,1.14l-2.43,4.36c-.53.94-1.16,2-1.76,3.14l-1.91,3.84q-1,2.07-2.2,4.4c-.74,1.58-1.45,3.29-2.24,5.05s-1.62,3.62-2.41,5.58l-2.37,6.14c-.41,1.06-.82,2.14-1.24,3.24l-1.15,3.4c-.78,2.29-1.57,4.66-2.39,7.08-3,9.78-5.89,20.67-8.31,32.23s-4,22.73-5.2,32.9c-1,10.18-1.81,19.38-2,27.12-.2,3.87-.24,7.37-.25,10.45s-.06,5.73,0,7.89.06,3.78.07,5v1.3a1.42,1.42,0,0,1,0,.45,2.59,2.59,0,0,1-.06-.44c0-.35,0-.77-.09-1.3,0-1.21-.14-2.88-.24-5s-.17-4.82-.17-7.9,0-6.59.11-10.47c.13-7.76.83-17,1.82-27.2,1.17-10.19,2.8-21.37,5.14-33s5.33-22.51,8.41-32.3l2.43-7.1c.4-1.14.79-2.28,1.17-3.39s.86-2.18,1.28-3.24c.84-2.13,1.64-4.18,2.42-6.15s1.69-3.79,2.48-5.57,1.54-3.46,2.3-5,1.56-3,2.27-4.39l2-3.81c.63-1.16,1.28-2.18,1.83-3.11l2.59-4.28.7-1.09A1.61,1.61,0,0,1,131.81,195.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,329.77a18.55,18.55,0,0,1-1.51,2.66c-1,1.67-2.48,4.13-4.16,7.22s-3.53,6.84-5.4,11.09a148.64,148.64,0,0,0-5.25,14.16A150.36,150.36,0,0,0,107,379.55c-.86,4.56-1.46,8.71-1.8,12.2s-.56,6.34-.64,8.31a18.5,18.5,0,0,1-.25,3.05,19.91,19.91,0,0,1-.11-3.06c0-2,.07-4.84.35-8.36a122.76,122.76,0,0,1,1.6-12.3,136,136,0,0,1,3.61-14.77,137.77,137.77,0,0,1,5.35-14.23,123.43,123.43,0,0,1,5.61-11.06c1.77-3.06,3.29-5.48,4.43-7.1A18.86,18.86,0,0,1,127,329.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.15 396.15 129.82 396.15 122.24 460.16 74.96 460.16 67.15 396.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.44 453.25 74.76 460.16 122.24 460.16 127.72 453.48 69.44 453.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,415c0,.26-13,.47-29,.47s-29-.21-29-.47,13-.47,29.05-.47S127.38,414.72,127.38,415Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,419.24c0,.26-13,.47-29,.47s-29-.21-29-.47,13-.47,29.05-.47S127.38,419,127.38,419.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,423.37c0,.26-12.55.46-28,.46s-28-.2-28-.46,12.55-.47,28-.47S126.6,423.11,126.6,423.37Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.78,174.33c-2.63,6.55-2.55,20.09,1.82,25.62,2.28,2.89,5.38,5.2,7,8.51,2.12,4.34,1.21,9.74-1.45,13.77s-6.85,6.85-11.26,8.83c-4.91,2.22-10.92,3.44-15.5.6-3.5-2.16-5.35-6.21-6.47-10.17-3.14-11.08-2-23,1.26-34.08S287.75,166,293,155.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.36,266.16l23.44-14.31S324,217.56,321.32,216.32s-38.61-6.53-38.61-6.53c-10.93,17.18-24.61,12.94-38.4,1.48-1.23.25-22.93,5.19-28.6,5.93s-22,26.76-22,26.76l18.52,32.39,1.4,33.56s1,23.87-2.91,36.19L309,349.29a126,126,0,0,1-2.26-15.51c-.37-4.17-1.5-8.33-.65-13.69C308.78,303.07,318.36,266.16,318.36,266.16Z",
    className: "colorToChange",
    style: {
      fill: "#339F9A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.22,227.34c1.48,4.94,14,12.26,18.4,9.52,1.39-.87,2.59-2.17,4.2-2.48,2-.4,3.93.88,5.88,1.53,4.58,1.51,10.45-.18,13.75,3.33,1.63,1.73,2.66,4.67,5,4.6a12.18,12.18,0,0,0,2.46-.68c2.65-.66,5.22,1.37,7.95,1.56a12.12,12.12,0,0,0,4.2-.71l19.6-5.74c1.42-.42,3-1,3.61-2.34a10.56,10.56,0,0,1-7.16-.3A20.7,20.7,0,0,0,279.3,234c-3.46-.71-6.61,2-10.05,2.85-3.62.85-7.35-.5-10.82-1.84l-17.77-6.83c-4.9-1.88-9.92-3.84-13.81-7.35-1.24-1.11-5.89,1.23-7.34.43a46.69,46.69,0,0,1-4.82-3.74c-.3-.22-3,2.21-4.19,3.49S205.22,227.34,205.22,227.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.68,309.91c4.36-1.84,11.84-4.74,16.49-5.61a31.84,31.84,0,0,1,10.43-.52c1.73.25,3.52.72,5.2.22s2.81-1.72,4.29-2.45c4.25-2.09,9.33.51,14-.1a4.76,4.76,0,0,0,3.11-1.45,2.34,2.34,0,0,0-.06-3.16,3.29,3.29,0,0,0-1.89-.6,41.9,41.9,0,0,0-6.72.08l-3.61.23a13.78,13.78,0,0,1-4.49-.2,28.76,28.76,0,0,1-4.09-1.84c-4.82-2.12-10.35-1.17-15.56-.44a21.48,21.48,0,0,1-7.83.08,9.19,9.19,0,0,0-2.67-.46c-1.53.09-2.82,1.22-4.33,1.47s-1.6-2.64-3-3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.31,264.94a5.52,5.52,0,0,1-1.75.75c-2.83.39-4.57-4.59-7.28-3.68-1,.35-1.73,1.56-2.84,1.69s-2.13-1.12-3.27-1.63c-2-.9-4.26.72-6.48.9-2.5.19-5.42-1.37-7.29.31-.73.65-1.15,1.74-2.1,2s-1.76-.39-2.65-.66c-2.72-.81-5.21,1.81-8,2.29-3.18.55-7-1.6-9.39.53-.86.75-1.38,2-2.48,2.29s-2.08-.34-3.14-.35c-2.44,0-4.68,3.22-6.74,1.9a2.9,2.9,0,0,0,2.62,2.05,14.09,14.09,0,0,0,3.53-.3c6.91-.85,13.93,3.65,20.63,1.76,1.85-.52,3.58-1.52,5.49-1.66,3.58-.26,6.82,2.52,10.4,2.39,2.79-.11,5.38-2,8.16-1.66s4.92,2.83,7.52,4.06c3.11,1.48,6.75,1.05,10.17.59l1-.23a67.86,67.86,0,0,0,3.43-13.59A10.8,10.8,0,0,0,309.31,264.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.26,324.79a7.37,7.37,0,0,0-3.73,1.51,6.1,6.1,0,0,1-3.78,1.3c-2.46-.26-4.66-3.28-6.81-2.06a12.88,12.88,0,0,0-1.51,1.36c-1.5,1.23-3.89.89-5.32,2.2-.74.67-1.14,1.73-2.05,2.16-1.71.8-3.33-1.18-5.06-1.95-2.7-1.21-5.77.67-8.73.61-1.5,0-3.09-.55-4.45.07a15.94,15.94,0,0,0-2,1.42c-2.26,1.51-5.3.81-7.83-.2s-5.17-2.28-7.84-1.75c-.74.15-1.58.61-1.56,1.37a1.55,1.55,0,0,0,.3.81c1.58,2.6,4.6,3.94,7.53,4.79,3.21.93,6.6,1.47,9.46,3.21,1.81,1.09,3.71,2.72,5.75,2.16,1.62-.44,2.61-2.12,4.17-2.72,2.2-.85,4.81.69,7-.22.73-.3,1.34-.86,2.08-1.13,1.93-.7,4.08.71,6.08.26a9.11,9.11,0,0,1,2.12-.56c1.91,0,3.15,2.63,5,2.38,1.16-.16,1.95-1.39,3.11-1.6,1.53-.29,3.26,1.26,4.5.32.28-.21.5-.55.86-.58s.79.49,1.08.89c1.35,1.78,5.47.63,7.55-.18l-1.35-12C305.9,325.14,302.63,324.79,301.26,324.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217,227.76c-1.86,5.88-2.59,12.32-.74,18.2a70.76,70.76,0,0,0,3.43,7.84,57.68,57.68,0,0,1,5,28.46,1.53,1.53,0,0,0,.12,1c.39.65,1.38.41,2.07.1l4.43-2c1.92,1.56,2.21,4.65,4.33,5.91s5.07-.15,7.19-1.69c4.65-3.41,9.06-7.37,11.76-12.47a48.59,48.59,0,0,0,3.77-11.22c.83-3.39,1.67-6.78,2.19-10.23a57.52,57.52,0,0,0-8.36-39.3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M310.91,233a1.89,1.89,0,0,1,.21.52c.14.41.32.91.53,1.53.45,1.4,1.07,3.32,1.83,5.65s1.66,5.26,2.66,8.4a66,66,0,0,1,2.52,10.52,32.47,32.47,0,0,1-.53,10.8,57.13,57.13,0,0,1-2.52,8.47c-.88,2.35-1.68,4.22-2.24,5.51q-.4.88-.66,1.47a2.16,2.16,0,0,1-.27.5,2,2,0,0,1,.17-.54l.57-1.51c.51-1.31,1.25-3.2,2.09-5.55a62.32,62.32,0,0,0,2.39-8.44,33,33,0,0,0,.48-10.65,67.8,67.8,0,0,0-2.46-10.44c-1-3.16-1.82-6-2.55-8.43s-1.26-4.28-1.67-5.7l-.44-1.56A2,2,0,0,1,310.91,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.56,262.6a23.6,23.6,0,0,0-.49-14.71,56.38,56.38,0,0,0-6.95-13.21c1.38,9.46,5.71,18.36,6.57,27.89"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.72,323.19a39.36,39.36,0,0,1,16.41-12.78,77.45,77.45,0,0,1,20.3-5.33c2.75-.4,5.74-.68,8.15.71s3.55,5.16,1.45,7a6.56,6.56,0,0,1-3.95,1.18c-9.62.7-19.78.73-28.1,5.63-3.29,1.93-6.21,4.59-9.84,5.76-1.65.53-4.09.23-4.26-1.49"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.76,303.79a2.65,2.65,0,0,1-.58,0l-1.66,0-1.21,0-1.42.09c-1,.08-2.19.12-3.47.31l-2,.25c-.7.1-1.41.25-2.16.38-1.5.24-3.07.65-4.73,1a79.4,79.4,0,0,0-10.47,3.63,88.82,88.82,0,0,0-9.87,5.07c-1.46.89-2.85,1.73-4.09,2.6s-2.42,1.65-3.47,2.41-2,1.48-2.78,2.1-1.51,1.18-2.06,1.64l-1.3,1a2.36,2.36,0,0,1-.48.33,3,3,0,0,1,.41-.41l1.23-1.12c.54-.49,1.21-1.07,2-1.71s1.69-1.41,2.74-2.17,2.17-1.64,3.44-2.48,2.64-1.74,4.09-2.65a84.6,84.6,0,0,1,9.91-5.14,74.3,74.3,0,0,1,10.56-3.61c1.68-.38,3.26-.79,4.77-1,.76-.12,1.48-.27,2.18-.36l2-.21c1.29-.17,2.46-.19,3.49-.24.52,0,1-.05,1.44-.05l1.21,0,1.67.06A2,2,0,0,1,288.76,303.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.65,250.53c-2.55,3.53-2.84,8.29-1.79,12.51s3.28,8,5.5,11.78a35.94,35.94,0,0,0-.86-11.18c-1.05-4.38-2.93-8.64-2.92-13.15"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M278.88,115.32c.06-3.19,3.7-5.45,6.85-4.91s5.61,3.09,7.08,5.92,2.18,6,3.29,9c3,8,8.89,14.89,11,23.21a35.11,35.11,0,0,1-.54,17.88A79.87,79.87,0,0,1,299.53,183a60.2,60.2,0,0,0-4.65,9.89,17.31,17.31,0,0,0-.33,10.76,2,2,0,0,1,.14,1.44c-.31.68-1.28.71-2,.52-3.67-.94-6.21-4.55-6.84-8.29s.33-7.56,1.67-11.11,3.06-7,4.05-10.61c2.16-8,.66-16.48.28-24.77-.21-4.67-.06-9.39-1-14s-3.11-9.14-7-11.75c-1.51-1-3.25-1.74-4.52-3s-1.91-3.51-.76-4.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.17,208.07s-.11-4.84-.11-4.79,14.33-2.73,16.86-21.56c1.26-9.36.43-24.65-.65-37.13-1-11.24-8.76-24.88-19.95-23.43l-34.81,9.68c-3.39.44-4.51,3.35-4.36,6.78l-.25,1.61,2.9,53.69,1,9c.51,10.21,9.38,21,20.32,21.28h0C273.68,223.72,282.31,219.37,282.17,208.07Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.87,156.7a2.41,2.41,0,0,1-2.27,2.48,2.3,2.3,0,0,1-2.53-2.11,2.41,2.41,0,0,1,2.26-2.48A2.31,2.31,0,0,1,291.87,156.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,153.14c-.29.32-2.14-1-4.73-.92s-4.46,1.41-4.74,1.1c-.15-.14.14-.71,1-1.34a6.65,6.65,0,0,1,3.79-1.26,6.3,6.3,0,0,1,3.77,1.12C294.9,152.43,295.19,153,295,153.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.85,158c-.29.32-2.15-1-4.74-.91s-4.45,1.4-4.74,1.09c-.14-.13.15-.71,1-1.33a6.67,6.67,0,0,1,3.79-1.27,6.36,6.36,0,0,1,3.78,1.13C269.71,157.28,270,157.84,269.85,158Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.55,172.69c0-.15,1.59-.47,4.19-.86.66-.09,1.28-.23,1.38-.69a3.34,3.34,0,0,0-.49-1.95l-2.07-5c-2.88-7.11-5-13-4.7-13.07s2.86,5.55,5.74,12.66q1,2.63,2,5a3.81,3.81,0,0,1,.41,2.58,1.7,1.7,0,0,1-1.07,1,4.54,4.54,0,0,1-1.12.18C281.19,172.78,279.56,172.83,279.55,172.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06,203.28a47.74,47.74,0,0,1-25.28-6.11s6.65,13.1,25.39,10.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,151.43c-.29.69-2.85.2-5.91.37s-5.56.86-5.92.2c-.16-.31.3-.95,1.34-1.57a9.93,9.93,0,0,1,4.45-1.25,9.75,9.75,0,0,1,4.56.82C269.36,150.52,269.88,151.1,269.75,151.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.65,145.15c-.52.6-2.65,0-5.18.08s-4.68.5-5.19-.1c-.22-.3.1-.89,1-1.47a8.61,8.61,0,0,1,8.35,0C294.57,144.26,294.88,144.86,294.65,145.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,178.12a4.29,4.29,0,0,0-3.23-1.62,5.09,5.09,0,0,0-3.71,1.78l-.07.06-.13.14,0,0a2.41,2.41,0,0,0-.64,1.4,3.6,3.6,0,0,0,1.54,3,4.55,4.55,0,0,0,5.23.2A3.71,3.71,0,0,0,277.62,178.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,175.61c.15,0,.27.6.68,1.45a6.4,6.4,0,0,0,2.38,2.65,6.3,6.3,0,0,0,3.46.83c.94,0,1.53-.22,1.6-.08s-.47.54-1.51.78a5.7,5.7,0,0,1-4.06-.68,5.63,5.63,0,0,1-2.52-3.25C270.64,176.28,270.78,175.61,270.9,175.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6,121.47a5.83,5.83,0,0,0,2,5.06,28.6,28.6,0,0,0,4.71,3.18c5,3.12,7.47,9.94,9.81,15.35,4.12-7.85-2.21-18-7.45-24.15a11.35,11.35,0,0,0-3.26-2.84,4.79,4.79,0,0,0-4.2-.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,184.08a4.57,4.57,0,0,1,.22-.7l.72-1.94c.57-1.71,1.41-4.18,2.16-7.31a70,70,0,0,0,1.37-25,56,56,0,0,0-3.24-13.39,23.55,23.55,0,0,0-6.25-9.21,16.94,16.94,0,0,0-6.59-3.62c-1.73-.45-2.74-.45-2.74-.51a3.37,3.37,0,0,1,.73,0,13.3,13.3,0,0,1,2.06.32,16.41,16.41,0,0,1,6.78,3.53,23.75,23.75,0,0,1,6.46,9.31,54.78,54.78,0,0,1,3.31,13.51,68,68,0,0,1-1.53,25.1,69.62,69.62,0,0,1-2.33,7.3c-.34.83-.62,1.48-.81,1.91A3.55,3.55,0,0,1,299.17,184.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.86,197.58a.73.73,0,0,1-.09-.22l-.22-.67a12.94,12.94,0,0,1-.43-2.64,19.59,19.59,0,0,1,2.25-9.54c1.77-3.81,5-7.63,8.1-12.12a31,31,0,0,0,3.92-7.55,23.17,23.17,0,0,0,1.06-9,22.88,22.88,0,0,0-2.47-8.74,34.11,34.11,0,0,0-5-6.92c-3.66-4-7.34-7.42-9.75-10.85a22.82,22.82,0,0,1-4.16-8.88,11.86,11.86,0,0,1-.23-3.6,22.65,22.65,0,0,0,.43,3.56,23.18,23.18,0,0,0,4.26,8.71c2.42,3.36,6.09,6.68,9.81,10.74a34.22,34.22,0,0,1,5.07,7,23.46,23.46,0,0,1,2.53,8.93,23.79,23.79,0,0,1-1.09,9.22,31.24,31.24,0,0,1-4,7.66c-3.15,4.51-6.38,8.28-8.17,12a19.6,19.6,0,0,0-2.37,9.36A17.31,17.31,0,0,0,300.86,197.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,111.63c-3.21-2.27-7.35-2.79-11.28-2.73-10.6.15-21.36,4.2-28.45,12.08-6,6.64-14.81,19.42-16.48,28.18-4.07,21.35,9.42,27.33-1.57,60.66-2,6-4.48,11.88-5.7,18.08a32.08,32.08,0,0,0-.61,6.72c-1.29,3.9-.5,8.4,1.09,12.28,1.87,4.56,4.72,8.66,6.51,13.25s5.73,12.12,3.1,16.29c3.71-1,3.84-4.87,6.78-7.34a19.33,19.33,0,0,1-.08,10.1A21.1,21.1,0,0,0,245.35,274c6.86-6,9-15.75,10.07-24.83,2.3-19.85.05-38.89-5.21-58.17l-.07.09c-3.83-12.33-11.08-23.71-4.57-26.43,11.34-4.73,1-9.71,5.3-21.63,1.35-3.72,2.85-7.66,6-10,3.78-2.82,8.89-2.67,13.6-2.93s10.05-1.5,12.26-5.66l.29-2.49C284.71,118.38,282.79,113.91,279.58,111.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44,190.56a4.45,4.45,0,0,0,.83-.84,5.07,5.07,0,0,0,.63-3.27c-.32-2.95-1.81-7-3.76-12a47.06,47.06,0,0,1-2.53-8.38,18.13,18.13,0,0,1,7.52-18.7c3.2-2.3,7.55-2.65,10.22-5.77s4-6.86,5.16-10.48a48.2,48.2,0,0,1,2-5.32,27.69,27.69,0,0,1,2.8-4.69,27.34,27.34,0,0,1,7.36-6.83,17,17,0,0,1,4.14-2,12.09,12.09,0,0,1,4.2-.5,22.43,22.43,0,0,1,7,1.74c2,.81,3.64,1.52,5,2.24a7.69,7.69,0,0,1,2.63,2.22,3.55,3.55,0,0,1,.53,1.08,10.4,10.4,0,0,0-.62-1,7.77,7.77,0,0,0-2.64-2.1c-1.32-.68-3-1.37-5-2.15A22.33,22.33,0,0,0,267,112.2a11.53,11.53,0,0,0-4.07.51,17.32,17.32,0,0,0-4,1.94A27,27,0,0,0,249,126a48.26,48.26,0,0,0-2,5.27c-1.18,3.61-2.41,7.58-5.26,10.67a13.24,13.24,0,0,1-5.1,3.33,25.37,25.37,0,0,0-5.21,2.52,18,18,0,0,0-6.64,8.45A18.21,18.21,0,0,0,224,166a47.59,47.59,0,0,0,2.46,8.33c1.9,5,3.35,9.09,3.61,12.11a5,5,0,0,1-.75,3.34,3,3,0,0,1-.64.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,166.31c-.29-4-4.69-6.56-8.11-4.49-1.88,1.14-3.28,3.38-3,7.62.71,11.29,11.9,8.25,11.9,7.92S245.29,171,245,166.31Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,173.3s-.19.15-.51.32a2,2,0,0,1-1.47.13c-1.22-.37-2.34-2.2-2.52-4.23a6.46,6.46,0,0,1,.37-2.85,2.25,2.25,0,0,1,1.39-1.6,1,1,0,0,1,1.19.46c.17.31.11.54.18.56s.23-.21.11-.67a1.26,1.26,0,0,0-.49-.68,1.52,1.52,0,0,0-1.11-.22,2.77,2.77,0,0,0-1.94,1.88,6.65,6.65,0,0,0-.49,3.19c.22,2.27,1.52,4.33,3.18,4.7a2.14,2.14,0,0,0,1.78-.41C242,173.58,242.05,173.32,242,173.3Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.32,181s.08.22,0,.62a2.52,2.52,0,0,1-1,1.39,2.83,2.83,0,0,1-2.53.29,3.76,3.76,0,0,1-2.23-2.19,5.29,5.29,0,0,1,1-5.36,2.9,2.9,0,0,1,2-1.12,6,6,0,0,0-1.72,1.36,5.22,5.22,0,0,0-1,2.12,4.94,4.94,0,0,0,.21,2.8,3.31,3.31,0,0,0,1.9,1.94,2.48,2.48,0,0,0,2.17-.15,2.59,2.59,0,0,0,1-1.14C246.25,181.22,246.27,181,246.32,181Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.4,123.19a15.9,15.9,0,0,0-2.39-2,13,13,0,0,0-8.18-1.72,15.21,15.21,0,0,0-5.59,1.68,21.27,21.27,0,0,0-5.31,4.12,36.61,36.61,0,0,0-4.51,6c-1.37,2.21-2.62,4.61-3.91,7.07a81,81,0,0,1-4,7.05,34.15,34.15,0,0,1-4.8,5.86c-1.72,1.69-3.44,3.2-4.91,4.74a21.49,21.49,0,0,0-3.58,4.65,12.05,12.05,0,0,0-1.44,8.21,9.57,9.57,0,0,0,1.24,2.86,5.88,5.88,0,0,1-.5-.65,7.51,7.51,0,0,1-.93-2.16,12,12,0,0,1,1.3-8.43,21.49,21.49,0,0,1,3.6-4.78c1.47-1.57,3.18-3.09,4.88-4.78a34.57,34.57,0,0,0,4.72-5.8c1.43-2.18,2.71-4.56,4-7s2.54-4.87,3.94-7.1a35.83,35.83,0,0,1,4.59-6,21.33,21.33,0,0,1,5.46-4.17,15.71,15.71,0,0,1,5.75-1.67,13,13,0,0,1,8.33,1.92,9.65,9.65,0,0,1,1.77,1.55A5.25,5.25,0,0,1,280.4,123.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.31,245.43l2.1-10.14-19.32-8.81-.5,1.65c-2.76,9.19-16.52,53.48-17.36,56.79-3.1,12.29-2.41,36.61,2.49,41.16,3.92,3.64,11.45,6.32,16.43,5.77s18.71-18.22,18.71-18.22l12.59-40.34Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.16,239.4a3.81,3.81,0,0,1-.09.78c-.1.56-.22,1.3-.38,2.24-.35,2-.86,4.77-1.47,8.19s-1.35,7.58-2,12.18a117.08,117.08,0,0,0-1.16,15,62,62,0,0,0,1.69,14.94c1.09,4.49,2.09,8.63,2,12.2a16.07,16.07,0,0,1-2.08,8,8.28,8.28,0,0,1-1.94,2.36,14.46,14.46,0,0,0,3.65-10.41c.06-3.5-1-7.58-2.09-12.08a61.8,61.8,0,0,1-1.74-15.05,110.78,110.78,0,0,1,1.21-15.09c.65-4.61,1.42-8.73,2.09-12.18s1.24-6.18,1.63-8.16c.2-.93.36-1.66.47-2.22A6.62,6.62,0,0,1,196.16,239.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,218.52l-3.74-4.14v-4.92l-3.88-5.58-7.74,1.24-2.37.2L200,194a47,47,0,0,1,3.48-8.37c2.76-5.52-1.68-8.05-1.68-8.05l-8.3,14.52-2.76,9.65-1.18-7.87s1.4-7.66,1.2-11.6-4.15-3.37-4.15-3.37l-3.16,17.33v8.67l-2.75-5.12s-.59-4.34-1-8.28-3.54-2.76-3.54-2.76v12.81l3.54,11.82s-2.33,15.25-2.72,15.84L195.21,242s4-3,4.77-3.21,10.64-7.49,10.64-7.49l6.89-7.29s1.18-.78,1.18-1.57S216.13,218.52,216.13,218.52Zm-9.45,4.73-3.94-1.78-2.17-5.32,1.61-2.91.56-1,.72-.5,2.63.5s1.18,3.75,1,5.52,2.17,3.55,2.17,3.55Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,211.71c0,.06-.36.1-.9-.07a4,4,0,0,1-1.8-1.26,3.87,3.87,0,0,1-.88-2c-.06-.56,0-.91.1-.9a5.55,5.55,0,0,0,3.48,4.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,221.92a34.49,34.49,0,0,1,.26-5.74,6.61,6.61,0,0,1,.27,2.89A6.39,6.39,0,0,1,213.6,221.92Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,229.37s-.5-.32-1.06-1.08a5.06,5.06,0,0,1-1-3.55,2.11,2.11,0,0,1,.48-1.05c.23-.25.47-.48.7-.69a14.91,14.91,0,0,1,1.28-1c.76-.54,1.3-.78,1.34-.7a10.71,10.71,0,0,1-1.11,1c-.35.3-.75.66-1.18,1.08-.21.21-.43.44-.64.68a1.68,1.68,0,0,0-.36.8,4,4,0,0,0,.19,1.83,6.14,6.14,0,0,0,.63,1.43C207.23,228.86,207.59,229.32,207.52,229.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4,213.88a6.08,6.08,0,0,1-1.31,4.06,3.6,3.6,0,0,1-1.34,1.13,2.34,2.34,0,0,1-1.45.13c-.85-.21-1.07-.79-1-.8s.37.36,1.07.44a2.06,2.06,0,0,0,1.18-.21,3.3,3.3,0,0,0,1.13-1A17.7,17.7,0,0,0,212.4,213.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,217.45c-.12,0-.41-1.74-1-3.87a23.7,23.7,0,0,1-.52-2.8c-.07-.73,0-1.19,0-1.19s.16.43.32,1.13c.23,1,.44,1.83.66,2.74C207.19,215.6,207.26,217.45,207.09,217.45Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,223.1a9.13,9.13,0,0,1-4.46-1.58,5.71,5.71,0,0,1-1.46-1.23,3.51,3.51,0,0,1-.66-1.43,2,2,0,0,1,.07-1.41c.09,0,0,.54.28,1.32a4.22,4.22,0,0,0,2,2.3C211.58,222.45,213.65,222.93,213.6,223.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.36,227.48A24.46,24.46,0,0,0,193,222.1a24.74,24.74,0,0,0-6-3.51,5.55,5.55,0,0,1,2,.52,15.14,15.14,0,0,1,7.51,6.46A5.46,5.46,0,0,1,197.36,227.48Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,209.09c0,.15-1.44.27-3.11.86s-2.88,1.36-3,1.24a7.44,7.44,0,0,1,6.08-2.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.42,428.7s-58.43,16.17-60.77,17c-3.52,1.24-2.93,14.14,2.55,13.94,2.59-.1,44.87,1.57,50.22,1.24s19.72-6,19.72-6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,451c-.3,0-.69-3.05-2.58-6.27s-4.31-5.14-4.13-5.38,3,1.42,5,4.89S198.32,451,198.08,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17,448.23c-.29,0-.88-2.71-2.43-5.76s-3.4-5.19-3.19-5.39,2.45,1.72,4.06,4.95S204.42,448.21,204.17,448.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.88,446.7c-.29,0-.07-2.94-1.36-6.17s-3.39-5.25-3.19-5.47,2.74,1.59,4.1,5.11S210.12,446.78,209.88,446.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85,439.15c-.11,0-.63-1.6-.63-4.34a20.36,20.36,0,0,1,.59-4.77,20.69,20.69,0,0,1,.87-2.71,3.29,3.29,0,0,1,.94-1.43,1.54,1.54,0,0,1,2,.1,2.52,2.52,0,0,1,.78,1.65,11.69,11.69,0,0,1,.08,1.54,13.64,13.64,0,0,1-.36,2.86,17.32,17.32,0,0,1-1.8,4.47c-1.36,2.37-2.54,3.58-2.63,3.52s.85-1.46,2-3.84a19.54,19.54,0,0,0,1.53-4.34,12.93,12.93,0,0,0,.28-2.67c0-.9,0-2-.54-2.46a.56.56,0,0,0-.77-.06,2.42,2.42,0,0,0-.64,1,22,22,0,0,0-.89,2.58,23.33,23.33,0,0,0-.77,4.56C208.74,437.48,209,439.13,208.85,439.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.92,438.56c0-.11,1.38-.59,3.77-.61a16.83,16.83,0,0,1,4.14.51,9,9,0,0,1,2.39.88,2.46,2.46,0,0,1,1.32,2.67,2.91,2.91,0,0,1-2.1,2.08,5.43,5.43,0,0,1-2.63,0,10,10,0,0,1-3.79-1.87,10.46,10.46,0,0,1-2.72-2.67c.11-.13,1.21.83,3.11,2.1A10.1,10.1,0,0,0,216,443.2a4.55,4.55,0,0,0,2.17,0,2,2,0,0,0,1.42-1.38,1.5,1.5,0,0,0-.87-1.63,8.66,8.66,0,0,0-2.12-.83,20.21,20.21,0,0,0-3.94-.69C210.38,438.48,208.94,438.72,208.92,438.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,451.62c-.29,0,0-2.53-1.15-5.27s-3-4.35-2.86-4.58,2.54,1.15,3.76,4.21S189.34,451.72,189.1,451.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.87,454.32a13.25,13.25,0,0,1-2.26,1.06,49.24,49.24,0,0,1-6.5,2c-5.59,1.41-13.56,2.21-22.31,2.12s-16.65-.5-22.37-.73l-6.77-.36a11.69,11.69,0,0,1-2.48-.26,11.77,11.77,0,0,1,2.49-.12l6.78,0,22.35.44A104.52,104.52,0,0,0,221,456.72C226.54,455.57,229.8,454.13,229.87,454.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.6,455.65c-.08.13-1.68-.8-4.38-2a20.39,20.39,0,0,0-11.06-1.83c-4.4.67-7.52,3.63-9.55,5.68s-3.25,3.54-3.37,3.44A18.09,18.09,0,0,1,206.1,457a22.55,22.55,0,0,1,3.87-3.62,13.9,13.9,0,0,1,6-2.56,19.28,19.28,0,0,1,11.5,2.18A15.63,15.63,0,0,1,231.6,455.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,458.17c-.1-.07.4-.84.86-2.2a11.2,11.2,0,0,0,.43-5.49,11.08,11.08,0,0,0-2.37-5c-.91-1.11-1.65-1.66-1.58-1.76s.92.31,2,1.38a9.95,9.95,0,0,1,2,11.05C173.73,457.56,173.05,458.23,173,458.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.73,346.17,206.23,372s-52.18-19.09-82.72-13.53c-11.61,2.12-24,28.47-7.12,45.39,16.51,16.51,46,39.85,101.42,47.4,1.38.19,24.07,5.06,22.67,4.89s31.81,5.09,31.81,5.09l7.8-29.47L342,441.51c36.46-2.49,54.3-41.48,32.35-54-20.48-11.71-59-12.64-59-12.64l-9.45-25.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,462.34c.17-1,.6-3.68,1.51-9.18.49-3,1.1-6.53,1.88-10.65.39-2.06.83-4.26,1.35-6.57.26-1.16.55-2.34.89-3.55.17-.6.35-1.21.57-1.82a5.56,5.56,0,0,1,.94-1.82l.09.45c-13.17-4.67-29.63-10.85-47.18-18.25-10.78-4.59-21-9.22-29.92-14.05a96.57,96.57,0,0,1-12.27-7.61c-3.64-2.69-6.88-5.37-9.92-7.71-6-4.75-11.48-7.82-15.56-9.12a23.29,23.29,0,0,0-2.73-.81,16.59,16.59,0,0,0-2-.44l-1.27-.23a2.05,2.05,0,0,1-.43-.1,2.09,2.09,0,0,1,.44,0l1.28.16a15.42,15.42,0,0,1,2.06.38,23.42,23.42,0,0,1,2.76.75,37,37,0,0,1,7.16,3.19,76.38,76.38,0,0,1,8.61,5.81c3.06,2.32,6.32,5,10,7.64a98.07,98.07,0,0,0,12.23,7.51c8.95,4.78,19.12,9.39,29.89,14,17.53,7.39,34,13.61,47.1,18.36l.36.13-.27.31a5.52,5.52,0,0,0-.81,1.61c-.22.59-.4,1.19-.57,1.78-.35,1.19-.64,2.37-.91,3.52-.54,2.3-1,4.49-1.4,6.54-.82,4.11-1.47,7.69-2,10.62s-1,5.18-1.26,6.77c-.16.78-.28,1.37-.38,1.77A3.89,3.89,0,0,1,273.52,462.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,391a1.43,1.43,0,0,1-.34,0l-1-.16c-.85-.11-2.08-.43-3.7-.58a72.47,72.47,0,0,0-13.72-.49,102.09,102.09,0,0,0-20.09,3.32c-3.71,1-7.57,2.16-11.52,3.53s-8,2.94-12.1,4.59a112,112,0,0,1-12.35,4.07c-4,1.12-8,2-11.79,2.72-7.57,1.48-14.45,2.39-20.23,3.09s-10.47,1.18-13.71,1.51l-3.73.37-1,.08c-.22,0-.33,0-.33,0a1.51,1.51,0,0,1,.32-.07l1-.14,3.71-.49,13.68-1.72c5.77-.77,12.64-1.72,20.17-3.23,3.77-.74,7.71-1.63,11.74-2.75a112.09,112.09,0,0,0,12.27-4.06c4.12-1.64,8.17-3.22,12.14-4.59s7.85-2.52,11.58-3.51a100,100,0,0,1,20.22-3.19,67.66,67.66,0,0,1,13.78.7c1.62.2,2.84.56,3.69.71l1,.22A1.19,1.19,0,0,1,362.3,391Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,380.43c0,.44-2.77,1.14-7.41,1.57a96.75,96.75,0,0,1-35.95-3.85c-4.43-1.4-7-2.69-6.9-3.11.3-.93,11.25,2,25.05,3.42S266.9,379.46,267,380.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.89,375.25a12.06,12.06,0,0,1-2,.55c-.67.14-1.47.34-2.39.62s-2,.55-3.12,1a77.62,77.62,0,0,0-7.9,3.13c-2.9,1.37-6,3-9.19,4.91a145.4,145.4,0,0,0-15.49,10.89c-1.89,1.51-3.41,2.76-4.45,3.64a12.85,12.85,0,0,1-1.67,1.3,12.62,12.62,0,0,1,1.5-1.5c1-.93,2.46-2.24,4.33-3.8a124.16,124.16,0,0,1,15.44-11.1,97.85,97.85,0,0,1,9.27-4.89,68.66,68.66,0,0,1,8-3c1.16-.38,2.23-.64,3.18-.87a24.66,24.66,0,0,1,2.42-.52A13.68,13.68,0,0,1,315.89,375.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.89,401.25a15.16,15.16,0,0,1-3.66-1.05,78,78,0,0,1-8.38-3.78l-8.11-4.25a27.16,27.16,0,0,1-3.34-1.81,17.37,17.37,0,0,1,3.54,1.39c2.14,1,5,2.45,8.21,4.08s6.1,3,8.25,3.94A35.88,35.88,0,0,1,257.89,401.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.53,347.69c.1,0-.07,2.38-.27,6.21s-.37,9.12-.28,15,.43,11.13.75,14.94.56,6.17.46,6.19a8.32,8.32,0,0,1-.33-1.62c-.18-1.06-.38-2.59-.6-4.5-.44-3.81-.85-9.12-.94-15s.15-11.2.47-15c.16-1.92.32-3.46.46-4.52A8.48,8.48,0,0,1,263.53,347.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.34,357.83c0,.06-.22.21-.54.58a3.7,3.7,0,0,0-.82,1.89,3.53,3.53,0,0,0,.8,2.8,3.3,3.3,0,0,0,5.46-2,3.55,3.55,0,0,0-1.22-2.65,3.68,3.68,0,0,0-1.85-.9c-.49-.07-.78,0-.79-.08s.27-.17.81-.18a3.63,3.63,0,0,1,2.13.8,3.91,3.91,0,0,1,1.53,3,3.86,3.86,0,0,1-6.52,2.42,3.91,3.91,0,0,1-.81-3.29,3.58,3.58,0,0,1,1.09-2A1.43,1.43,0,0,1,269.34,357.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.45,431s59.3,9,61.7,9.55c3.6.8,4.54,13.54-.87,14-2.55.21-43.9,6.82-49.19,7.12s-21.86-4-21.86-4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,450c.3,0,.32-3.08,1.79-6.47s3.64-5.56,3.43-5.76-2.78,1.74-4.32,5.38S306.74,450.08,307,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.67,448c.29,0,.55-2.77,1.72-5.95s2.72-5.49,2.49-5.66-2.2,2-3.4,5.33S300.43,448.05,300.67,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88,447.2c.29-.05-.28-2.89.62-6.22s2.71-5.56,2.48-5.74-2.5,1.87-3.42,5.49S294.66,447.31,294.88,447.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,439.67c.11,0,.42-1.65.11-4.35a20.64,20.64,0,0,0-1.15-4.61,19.26,19.26,0,0,0-1.17-2.56,3.25,3.25,0,0,0-1.09-1.3,1.55,1.55,0,0,0-2,.34,2.54,2.54,0,0,0-.57,1.71,12.66,12.66,0,0,0,.11,1.53,12.53,12.53,0,0,0,.69,2.76,17.62,17.62,0,0,0,2.29,4.18,11.66,11.66,0,0,0,3,3.15c.12-.11-1-1.33-2.43-3.54a18.68,18.68,0,0,1-2-4.08,13.23,13.23,0,0,1-.59-2.59c-.08-.89-.22-2,.24-2.47a.56.56,0,0,1,.75-.16,2.34,2.34,0,0,1,.75.93,19.92,19.92,0,0,1,1.17,2.43,22.65,22.65,0,0,1,1.3,4.39C294.92,438,294.85,439.66,295,439.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,439.09c0-.11-1.43-.42-3.77-.15a16.44,16.44,0,0,0-4,1,9,9,0,0,0-2.24,1.15,2.43,2.43,0,0,0-1,2.78,2.91,2.91,0,0,0,2.31,1.8,5.31,5.31,0,0,0,2.58-.32,10,10,0,0,0,3.51-2.28,10.22,10.22,0,0,0,2.35-2.94c-.12-.11-1.09,1-2.81,2.43a10.16,10.16,0,0,1-3.34,1.95,4.56,4.56,0,0,1-2.13.22,1.94,1.94,0,0,1-1.56-1.19,1.5,1.5,0,0,1,.66-1.71,9.16,9.16,0,0,1,2-1.06,19.52,19.52,0,0,1,3.79-1.14C293.43,439.19,294.86,439.25,294.87,439.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.88,449.59c.28-.07-.3-2.49.51-5.31s2.48-4.63,2.27-4.83-2.36,1.42-3.21,4.57S315.66,449.72,315.88,449.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.14,457a11.81,11.81,0,0,0,2.35.78,50.63,50.63,0,0,0,6.62,1.22,92.1,92.1,0,0,0,22.16-.55c8.59-1.13,16.3-2.45,21.89-3.34l6.61-1.15a12.3,12.3,0,0,0,2.4-.55,11.6,11.6,0,0,0-2.46.18l-6.65.84-21.91,3.06a103.93,103.93,0,0,1-22,.83C279.56,457.87,276.19,456.85,276.14,457Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,458.54c.1.13,1.56-1,4.07-2.46A20.12,20.12,0,0,1,289.32,453c4.4.15,7.81,2.69,10.05,4.47a35.64,35.64,0,0,0,3.71,3,18,18,0,0,0-3.26-3.51,23.3,23.3,0,0,0-4.24-3.1,13.61,13.61,0,0,0-6.23-1.8,19.08,19.08,0,0,0-11,3.49A15.64,15.64,0,0,0,274.6,458.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.42,282.08c-.23,1.46-1,41,1.36,44.59,3.71,5.7,15.67,15.9,23.11,13.11,12.07-4.53,14.8-30.06,14.58-25.32l-9.55-80.67H325.53L324,262.72,318.64,266a53,53,0,0,1-2.05,9.92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.53,233.79s-7.34-7.26-7.34-8.87-2.87-2.51-2.87-2.51l-4.66-2.32s-3-2.87-2.32-4.48a4.2,4.2,0,0,1,2-2.15s.23-3.94,3.16-5c0,0-2.75-3,0-5.19s3.41-1.26,3.41-1.26-.3-2.33,1.31-2.5,13.13-3.05,13.13-3.05a23.05,23.05,0,0,1,4.6,3.05c1.43,1.43,2.15,2.32,2.15,2.32a17.49,17.49,0,0,0,2.87-5.37c.71-2.69,1.79-10.75,9.85-10.39v2a21.79,21.79,0,0,0-3.23,7.88c-1.07,5-3,16.11-3,16.11l-.6,21.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,314.26a5.12,5.12,0,0,1-.16-.81c-.08-.54-.23-1.32-.31-2.35a50.27,50.27,0,0,1-.13-8.71,107.37,107.37,0,0,1,1.73-12.81c.87-4.78,2.05-10,2.93-15.52,1.72-11.07,1.94-21.24,2.22-28.58.13-3.63.24-6.59.31-8.69l.12-2.37a4.06,4.06,0,0,1,.08-.82,7.62,7.62,0,0,1,0,.83c0,.59,0,1.37,0,2.36,0,2.11-.08,5.07-.14,8.7A217.38,217.38,0,0,1,323,274.14c-.89,5.55-2.09,10.76-3,15.53a113.26,113.26,0,0,0-1.83,12.74,55.59,55.59,0,0,0,0,8.67c.05,1,.17,1.82.22,2.36A4.57,4.57,0,0,1,318.45,314.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,200.82c0,.07-.8.05-2.08.22s-3.06.35-5,.53A49.74,49.74,0,0,1,317,202a48.27,48.27,0,0,1,7.1-.91c2-.18,3.75-.31,5-.38A4.7,4.7,0,0,1,331.28,200.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.9,209.42a10.67,10.67,0,0,1-2.08-.07c-1.27-.08-3-.11-5-.16a38.14,38.14,0,0,1-5-.37,6.37,6.37,0,0,1-2-.51,12,12,0,0,1,2.07.14c1.27.11,3,.18,5,.22s3.74.14,5,.31A7,7,0,0,1,327.9,209.42Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.25,216.37a8.76,8.76,0,0,1-2.12-.25c-1.3-.22-3.08-.56-5.05-1s-3.74-.8-5-1.11a8.78,8.78,0,0,1-2.05-.61,8.78,8.78,0,0,1,2.13.25c1.29.22,3.08.56,5,1s3.73.8,5,1.12A8.78,8.78,0,0,1,325.25,216.37Z",
    style: {
      fill: "#eb996e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.3344c6942cffc7919364686dd524b53f.svg";
export { ForwardRef as ReactComponent };